import aiAutomationHero from "../assets/img/ai-automationhero.png";
import benefitsImg from "../assets/img/benefits.png";
import useCasesImg from "../assets/img/use-cases.jpeg";
import howItWorksImg from "../assets/img/how-it-works.png";
import techStackImg from "../assets/img/tech-stack.png";

const blogImagesBySlug = {
  "ai-automation-for-small-business-benefits-cost-use-cases": aiAutomationHero,
  "how-ai-automation-helps-small-businesses-in-india-save-10-hours-per-week": benefitsImg,
  "ai-automation-use-cases-that-deliver-the-fastest-roi-in-india": useCasesImg,
  "how-to-choose-the-right-ai-automation-workflow-for-your-business": howItWorksImg,
  "how-to-build-a-smarter-operations-stack-for-a-growing-brand": techStackImg,
};

export const getBlogImage = (post, fallbackImage) =>
  post?.image || blogImagesBySlug[post?.slug] || fallbackImage;

export default blogImagesBySlug;
